import * as React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { TextBox } from "../../../forms/informedv2/TextBox";
import { Checkbox } from "../../../forms/informedv2/Checkbox";
import { MultiSelect } from "../../../forms/informedv2/MultiSelect";
import "./CoughSettings.scss";
import { useArrayField, useField, ArrayFieldProps } from "informed";
import { DeviceButtonOptions } from "./CoughSettings";

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "#f1f2f2",
    padding: 8,
    width: "auto"
});

export interface CoughEventTypeItemState {
    id: string;
    name: string;
    description: string;
    order: number;
    color: string;
    hidden: boolean;
    period: boolean;
    counted: boolean;
    deviceButton: { Text: string, Value: number }
;
}

export const getBinStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "#f1f2f2",
    padding: 8,
    height: "10%",
    width: "auto"
});

export interface CorrectedArrayFieldProps extends ArrayFieldProps {
    index: number;
}

interface CoughEventTypeDroppableProps {
    eventTypes: CorrectedArrayFieldProps[];
}

export const CoughEventTypeDroppable = ({ eventTypes }: CoughEventTypeDroppableProps) => {
    return (
        <div className="col-md-12">
            <Droppable droppableId="EventType">
                {(provided, snapshot) => (
                    <div
                        id="EventTypeRoot"
                        className="well"
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {eventTypes.map(({ field, key, index }) => (<CoughEventTypeDraggable key={key} id={key} field={field} index={index} onRemove={() => eventTypes[index].remove()} />))}
                            {provided.placeholder}
                    </div>
                )}
            </Droppable>
            <Droppable droppableId="Delete">
                {(provided, snapshot) => (
                    <div
                        className="well"
                        ref={provided.innerRef}
                        style={getBinStyle(snapshot.isDraggingOver)}
                    >
                        <i className="fas fa-lg fa-trash text-danger"></i>
                        &nbsp; Drag here to remove an item
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    );
}

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => {
    return {
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,
        textAlign: "left",
        background: isDragging ? "lightgreen" : "#fff",
        ...draggableStyle
    };
};

export const CoughEventTypeDraggable = ({ id, field, index, onRemove }) => {
    const colorField = useField<string>({ field: `${field}.color` });
    const order = useField<number>({ field: `${field}.order` });

    

    return (
        <Draggable key={id} draggableId={id} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                >
                    <div onClick={e => e.stopPropagation()}>
                        <div className="row">
                            <div className="col-md-1">
                                <span {...provided.dragHandleProps}>
                                    <i
                                        className="fas fa-grip-vertical fa-2x"
                                        style={{ float: "left" }}
                                    />
                                </span>
                            </div>

                            <div className="col-md-10">
                                <div className="row">
                                    <div className="form-group col-md-4">
                                        <label>Name</label>
                                        <TextBox<string, CoughEventTypeItemState> id={`${field}.id`} field={`${field}.id`} type="hidden" />
                                        <TextBox<number, CoughEventTypeItemState> id={`${field}.name`} field={`${field}.name`} required />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Description</label>
                                        <TextBox<number, CoughEventTypeItemState> id={`${field}.description`} field={`${field}.description`} />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <label>Colour</label>
                                        <input type="color" className="form-control" value={colorField.fieldState.value} onChange={(e: any) => colorField.fieldApi.setValue(e.target.value)} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="form-group col-md-4">
                                        <label>Associated Device Button</label>
                                        <MultiSelect
                                            id={`${field}.deviceButton`}
                                            field={`${field}.deviceButton`}
                                            options={DeviceButtonOptions}
                                            labelKey="Text"
                                            valueKey="Value"
                                        />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Event Period</label>
                                        <Checkbox id={`${field}.period`} field={`${field}.period`} label="" />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Hidden</label>
                                        <Checkbox id={`${field}.hidden`} field={`${field}.hidden`} label="" />
                                    </div>
                                    <div className="form-group col-md-2">
                                        <label>Event Counted</label>
                                        <Checkbox id={`${field}.counted`} field={`${field}.counted`} label="" />
                                    </div>

                                </div>
                            </div>

                            <div className="col-md-1">
                                <span className="pull-right">
                                    <i className="fas fa-times" style={{ cursor: "pointer" }} onClick={() => onRemove()} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Draggable>
    );
}
